// import * as $ from 'jquery';

import {
  EnvironmentProviders,
  Inject,
  NgModule,
  Provider,
} from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { startCase, toLower } from 'lodash';
import { providePrimeNG } from 'primeng/config';
import {
  APP,
  HubComponentsModule,
  SESSION_SERVICE_APP_INITIALIZER,
  ObjectBaseService,
  SharedObjectBaseService,
} from '@hub-components';
import { AppRouterModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DiscoveriesService } from './apps/discovery/app/services/discoveries/discoveries.service';
import { SharedDiscoveriesService } from './apps/discovery/app/services/shared-discoveries/shared-discoveries.service';
import { ReportsService } from './apps/reports/app/services/reports.service';
import { SharedReportsService } from './apps/reports/app/services/shared-reports.service';
import { SnapshotService } from './apps/snapshot/app/services/snapshot/snapshot.service';
import { DashboardsService } from './apps/studio/app/services/dashboards.service';
import { SharedDashboardsService } from './apps/studio/app/services/shared-dashboards.service';
import { FallbackComponent } from './fallback.component';
import { primengAppThemePreset } from './primeng-theme.preset';
import { ROLLBAR_ERROR_HANDLER } from './rollbar/rollbar-error-handler';
import { RollbarServiceToken, rollbarFactory } from './rollbar/rollbar.config';

declare var location: Location;
export function appName() {
  return location.hostname.split('.', 2)[0].replace(/-u$/, '').replace(/-/g, '_');
}

const COMPONENTS = [AppComponent];

export const PROVIDERS: Array<Provider | EnvironmentProviders> = [
  provideHttpClient(withInterceptorsFromDi()),
  provideAnimationsAsync(),
  { provide: APP, useFactory: appName },
  { provide: RollbarServiceToken, useFactory: rollbarFactory },
  ROLLBAR_ERROR_HANDLER,
  SESSION_SERVICE_APP_INITIALIZER,
];

const MODULES = [
  BrowserModule,
  AngularSvgIconModule.forRoot(),
  HubComponentsModule.forRoot(),
];

/**
 * This is an alternative to the provide and useclass override per app.module
 * After migration it stopped working as it needs to be done from the root app.
 */
addProvidersPerApp(appName());

@NgModule({
  declarations: [
    FallbackComponent,
    COMPONENTS
  ],
  imports: [
    MODULES,
    AppRouterModule,
  ],
  providers: [
    ...PROVIDERS,
    providePrimeNG({
      ripple: false,
      theme: {
        preset: primengAppThemePreset,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'legacy, tailwind-base, tailwind-components, primeng, tailwind-utilities',
          },
        },
      },
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(@Inject(APP) app, title: Title) {
    title.setTitle(startCase(toLower(app)));
  }
}

function addProvidersPerApp(appName) {
  switch (appName) {
    case 'studio':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: DashboardsService },
        { provide: SharedObjectBaseService, useClass: SharedDashboardsService },
      );
      break;
    case 'reports':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: ReportsService },
        { provide: SharedObjectBaseService, useClass: SharedReportsService },
      );
      break;
    case 'discovery':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: DiscoveriesService },
        { provide: SharedObjectBaseService, useClass: SharedDiscoveriesService },
      );
      break;
    case 'snapshot':
      PROVIDERS.push(
        { provide: ObjectBaseService, useClass: SnapshotService },
      );
      break;
    default:
      break;
  }
}
